// Display labels and colors of the warranty module (translated through the dashboard namespace).

export const ACCEPTANCE_COLORS = {
  draft: "default",
  requested: "processing",
  accepted: "success",
  refused: "error"
};

export const acceptanceStatusLabels = t => ({
  draft: t("Draft"),
  requested: t("Deadline running"),
  accepted: t("Accepted"),
  refused: t("Acceptance refused")
});

export const basisLabels = t => ({
  vob: t("VOB/B contract"),
  bgb: t("BGB contract"),
  bgb_consumer: t("BGB consumer contract")
});

export const methodLabels = t => ({
  formal: t("Formal acceptance with protocol"),
  implied: t("Acceptance by conduct"),
  fictitious_completion: t("Fictitious: notice of completion (§ 12 (5) 1 VOB/B)"),
  fictitious_use: t("Fictitious: client started using it (§ 12 (5) 2 VOB/B)"),
  fictitious_deadline: t("Fictitious: deadline expired (§ 640 (2) BGB)")
});

export const categoryLabels = t => ({
  building: t("Building work"),
  maintenance_parts: t("Maintenance-relevant parts of machinery/electrical systems"),
  fire_parts: t("Fire-touched parts of firing systems"),
  industrial_fire_parts: t("Parts of industrial firing systems"),
  other_work: t("Other work (repair, maintenance, alteration)"),
  custom: t("Agreed period")
});

export const DEFECT_COLORS = { open: "error", fixed: "warning", accepted: "success" };

export const defectStatusLabels = t => ({
  open: t("Open"),
  fixed: t("Fixed, awaiting confirmation"),
  accepted: t("Fix confirmed")
});

export const CLAIM_COLORS = {
  open: "error",
  in_progress: "processing",
  fixed: "warning",
  accepted: "success",
  rejected: "default"
};

export const claimStatusLabels = t => ({
  open: t("Open"),
  in_progress: t("In progress"),
  fixed: t("Fixed"),
  accepted: t("Fix accepted"),
  rejected: t("Rejected")
});

export const STATE_COLORS = {
  pending: "default",
  active: "success",
  expiring: "warning",
  expired: "default"
};

export const stateLabels = t => ({
  pending: t("Not started"),
  active: t("Running"),
  expiring: t("Ending soon"),
  expired: t("Ended")
});

export const GUARANTEE_COLORS = {
  active: "processing",
  return_requested: "warning",
  returned: "success",
  drawn: "error"
};

export const guaranteeStatusLabels = t => ({
  active: t("Active"),
  return_requested: t("Return requested"),
  returned: t("Returned"),
  drawn: t("Drawn")
});

export const guaranteeTypeLabels = t => ({
  contract_performance: t("Performance bond"),
  warranty: t("Warranty bond"),
  advance_payment: t("Advance payment bond")
});

export const directionLabels = t => ({
  given: t("Given by us"),
  received: t("Received from subcontractor")
});

/** Why a return date or fictitious acceptance cannot be computed. */
export const reasonLabels = t => ({
  VOB_ONLY: t("Only possible in a VOB/B contract."),
  NO_TRIGGER_DATE: t("Please enter the date."),
  NO_DEADLINE: t("Please enter the deadline."),
  DEADLINE_BEFORE_REQUEST: t("The deadline must be after the request."),
  CONSUMER_NOTICE_MISSING: t(
    "A consumer must have been told the consequences in text form (§ 640 (2) sentence 2 BGB)."
  ),
  NO_ACCEPTANCE: t("Known after the acceptance."),
  NO_WARRANTY_END: t("Known after the acceptance."),
  ADVANCE_NOT_OFFSET: t("Enter the day the advance was offset."),
  NOT_FICTITIOUS: ""
});

/** Legal source as shown ("agreed" and "warranty_end" are words, not paragraphs). */
export const sourceLabel = (t, source) =>
  source === "agreed"
    ? t("as agreed")
    : source === "warranty_end"
      ? t("end of warranty")
      : source === "acceptance"
        ? t("with the acceptance")
        : source || "";
